

// Really a reference -- forget BB model here ...

module.exports = function( options ) {

    this.originalId = options.originalId;
    this.pageLevelKey = options.pageLevelKey;
    this.parentId = options.parentId;

    this.pageId = options.pageId;
    this.pageNumber = options.pageNumber;

};




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/positionalTextModels/textAreaModels/subWordReference.js
 ** module id = 409
 ** module chunks = 0
 **/